import tw from "twin.macro";

export const light = tw`bg-transparent border border-tiara border-solid rounded-2xl p-1`;

export const dark = tw`bg-dark border border-dark border-solid rounded-full p-1`;
